import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { ContactConsultationConfirmPage } from '@/pages/contact/consultation/ContactConsultationConfirm/ContactConsultationConfirmPage';
import { pagePath } from '@/utils/router/pagePath';
/**
 * コンサル選定のご相談の確認ページ（認証以外のアクセス制限）
 */
export const ContactConsultationConfirm = (props) => {
    const { formState } = props;
    if (!formState) {
        return _jsx(CustomRedirect, { to: pagePath.contact.consultation() });
    }
    return _jsx(ContactConsultationConfirmPage, { formState: formState });
};
